import { MapMarkerType } from '../../../../../store/mst/models';

// Places value on a scale from 0 to 50 based on latitude, used for z-index
export const reverseLinearScale = (
  min: number, max: number, val: number = 1, domain = 50,
): number => ((max - val) / (max - min)) * domain;

// Retrieves and sorts leaves from a cluster by latitude.
const getClusterLeavesSortedByLatitude = (clusteredIndex: any, clusterId: number): MapMarkerType[] => {
  const leaves = clusteredIndex.getLeaves(clusterId, Infinity);

  return leaves
    .sort((a: MapMarkerType, b: MapMarkerType) => {
      const latitudeA = a.geometry.coordinates[1];
      const latitudeB = b.geometry.coordinates[1];
      return latitudeB - latitudeA;
    })
    .map((leaf: MapMarkerType, index: number) => ({
      ...leaf,
      properties: {
        ...leaf.properties,
        rank: index + 1,
        rankMax: leaves.length,
      },
    }));
};

// Performs rank transformation on clustered data for zIndex based on latitude
export const rankTransformClusteredData = (
  clusteredIndex: any,
  z: number,
): MapMarkerType[] => {
  // Retrieve clusters within the specified bounds and zoom level
  const clusteredData = clusteredIndex.getClusters([-180, -90, 180, 90], z);

  // Expand clustered data into individual points.
  return clusteredData.flatMap((item: MapMarkerType) => {
    if (item.properties.cluster) {
      return getClusterLeavesSortedByLatitude(clusteredIndex, item.properties.cluster_id);
    }
    return {
      ...item,
      properties: {
        ...item.properties,
        rank: 1, // No need to rank isolated points
        rankMax: 1,
      },
    };
  });
};
